/* v0.2 autonomous routes, catalogue controls and responsive interactions. */
(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const routes = JSON.parse($('#theme-routes')?.textContent || '{}');
  const legacy = JSON.parse($('#theme-legacy-routes')?.textContent || '{}');
  const productHandles = JSON.parse($('#theme-product-handles')?.textContent || '{}');
  const rootPath = routes.root || '/';
  const current = new URL(location.href);
  function normalize(path) {
    try { return decodeURIComponent(path).replace(/\/$/, '') || '/'; }
    catch { return path.replace(/\/$/, '') || '/'; }
  }
  function viewURL(suffix, hash = '') {
    const url = new URL(rootPath, location.origin);
    url.searchParams.set('view', suffix);
    const preview = current.searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = hash;
    return url.pathname + url.search + url.hash;
  }
  function fixLinks(scope = document) {
    $$('a[href]', scope).forEach(link => {
      if (link.hasAttribute('data-external-service')) return;
      const raw = link.getAttribute('href');
      if (!raw || raw.startsWith('#')) return;
      let url;
      try { url = new URL(raw, location.href); } catch { return; }
      if (url.origin !== location.origin && url.hostname !== 'fr.erborian.com') return;
      const suffix = legacy[normalize(url.pathname)];
      if (suffix) link.href = viewURL(suffix, url.hash);
      else if (url.hostname === 'fr.erborian.com' && /-([A-Z0-9.]+)\.html$/.test(url.pathname)) {
        const code = url.pathname.match(/-([A-Z0-9.]+)\.html$/)[1];
        const handle = productHandles[code];
        if (handle) {
          const target = new URL(`${rootPath}products/${handle}`,location.origin);
          if(current.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));
          link.href = target.pathname + target.search + url.hash;
        }
      }
      else if (url.origin === location.origin && current.searchParams.has('preview_theme_id')) {
        url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
        link.href = url.pathname + url.search + url.hash;
      }
    });
  }
  fixLinks();
  if (document.body.dataset.template === '404') {
    const suffix = legacy[normalize(location.pathname)];
    if (suffix) location.replace(viewURL(suffix, location.hash));
  }

  function catalogue(scope = document) {
    $$('[data-forced-collection]', scope).forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const grid = $('[data-product-grid]', section);
      const cards = $$('[data-catalog-card]', section);
      const order = JSON.parse($('[data-member-order]', section).textContent);
      const ranks = new Map(order.map((handle, index) => [handle, index]));
      const sort = $('[data-forced-sort]', section);
      const stock = $('[data-available-filter]', section);
      const minimum = $('[data-min-price]', section);
      const maximum = $('[data-max-price]', section);
      const more = $('[data-catalog-more]', section);
      let limit = 12;
      function update() {
        const min = minimum.value === '' ? 0 : Number(minimum.value) * 100;
        const max = maximum.value === '' ? Infinity : Number(maximum.value) * 100;
        const filtered = cards.filter(card => (!stock.checked || card.dataset.available === 'true') && Number(card.dataset.price) >= min && Number(card.dataset.price) <= max);
        filtered.sort((a,b) => {
          if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (sort.value === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title, 'fr');
          return (ranks.get(a.dataset.handle) ?? Infinity) - (ranks.get(b.dataset.handle) ?? Infinity);
        });
        cards.forEach(card => {card.hidden = true;});
        filtered.forEach((card,index) => {grid.append(card);card.hidden = index >= limit;});
        $('[data-result-count]', section).textContent = `${filtered.length} produit${filtered.length === 1 ? '' : 's'}`;
        $('[data-no-results]', section).hidden = filtered.length > 0 || cards.length === 0;
        $('[data-catalog-pagination]', section).hidden = filtered.length === 0;
        $('[data-catalog-progress]', section).textContent = `${Math.min(limit, filtered.length)} produits sur ${filtered.length}`;
        more.hidden = limit >= filtered.length;
      }
      [sort, stock, minimum, maximum].forEach(control => control.addEventListener('change', () => {limit = 12;update();}));
      $('[data-reset-filters]',section).addEventListener('click', () => {stock.checked = false;minimum.value = '';maximum.value = '';limit = 12;update();});
      more.addEventListener('click', () => {limit += 12;update();});
      update();
    });
  }

  function galleries(scope = document) {
    $$('.erb-gallery', scope).forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const viewport = $('.erb-product-gallery',root);
      const slides = [...viewport.children];
      const thumbs = $$('[data-gallery-index]',root);
      const prev = $('[data-gallery-prev]',root), next = $('[data-gallery-next]',root);
      let index = 0;
      function paint() {
        index = Math.max(0,Math.min(slides.length-1,Math.round(viewport.scrollLeft / (viewport.clientWidth || 1))));
        const count = $('[data-gallery-count]',root);
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
        thumbs.forEach((button,i) => button.setAttribute('aria-pressed', String(i === index)));
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index >= slides.length - 1;
      }
      function go(i) {
        viewport.scrollTo({left:Math.max(0,Math.min(slides.length-1,i))*viewport.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      }
      thumbs.forEach((button,i) => button.addEventListener('click', () => go(i)));
      prev?.addEventListener('click', () => go(index-1));
      next?.addEventListener('click', () => go(index+1));
      viewport.addEventListener('scroll', paint, {passive:true});
      viewport.addEventListener('keydown', e => {if(e.key==='ArrowRight'){e.preventDefault();go(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();go(index-1);}});
      root.closest('[data-product-root]')?.addEventListener('variant:change', () => {viewport.scrollTo({left:0,behavior:'auto'});paint();});
      paint();
    });
  }

  function footer(scope = document) {
    $$('.erb-footer .m-footer-menu-item',scope).forEach((item,index) => {
      if (item.matches('.m-footer-social,.m-footer-badges') || item.dataset.footerAccordion) return;
      const heading = $('h2', item), list = $('ul', item);
      if (!heading || !list) return;
      item.dataset.footerAccordion = 'true';
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = heading.textContent.trim();
      list.id = `FooterLinks-${index}`;
      button.setAttribute('aria-controls',list.id);
      const mobile = matchMedia('(max-width:63.99875em)');
      const sync = () => button.setAttribute('aria-expanded',String(!mobile.matches || item.classList.contains('is-open')));
      button.addEventListener('click', () => {if (mobile.matches) {item.classList.toggle('is-open');sync();}});
      mobile.addEventListener('change',sync);
      heading.replaceChildren(button);
      sync();
    });
  }
  function accordions(scope = document) {
    $$('.o-expandable .a-expandable-toggle',scope).forEach((button,index) => {
      const group = button.closest('.o-expandable');
      const panel = $('.o-expandable-content',group);
      if (!panel) return;
      if (!panel.id) panel.id = `Expandable-${document.querySelectorAll('[id^="Expandable-"]').length}-${index}`;
      button.setAttribute('aria-controls',panel.id);
      const open = group.classList.contains('js--expanded');
      button.setAttribute('aria-expanded',String(open));
      panel.setAttribute('aria-hidden',String(!open));
      panel.hidden = !open;
    });
  }
  document.addEventListener('click', e => {
    const service = e.target.closest('.js--reinsurance-button');
    if (service) {
      const content = $('.js--reinsurance-content',service.closest('.m-reinsurance-item'));
      const dialog = $('#erb-information-dialog');
      if (content && dialog) {
        $('[data-information-content]',dialog).replaceChildren(...[...content.childNodes].map(node=>node.cloneNode(true)));
        dialog.showModal();
      }
    }
    if (e.target.closest('[data-close-information]')) $('#erb-information-dialog').close();
    if (!e.target.closest('.erb-header')) {
      $('#ErborianNav')?.classList.remove('is-open');
      $('[data-mobile-menu]')?.setAttribute('aria-expanded','false');
    }
  });
  document.addEventListener('keydown',e => {
    if(e.key === 'Escape' && e.target.closest('#ErborianNav')) $('[data-mobile-menu]')?.focus();
  });
  catalogue();galleries();footer();accordions();
  document.addEventListener('shopify:section:load', e => {fixLinks(e.target);catalogue(e.target);galleries(e.target);footer(e.target);accordions(e.target);});
})();
